import { useEffect, useState } from 'react'
import { languages } from '../../../../configs/language'
import EventEmitter, {
  DOWNLOAD_PDF,
  END_PROCESS_DOWNLOAD_PDF,
} from '../../../helpers/EventEmitter'
import { TYPE_DOWNLOAD } from '../constant'
import ComponentsToPdfData from './ComponentsToPdfData'
import LoadingPdf from './LoadingPdf'
import PdfDataToPdfFile from './PdfDataToPdfFile'
import PopupPreviewSingleBox from './PopupPreviewSingleBox'

const Pdf = () => {
  const [items, setItems] = useState(null)
  const [typeDownload, setTypeDownload] = useState(null)
  const [data, setData] = useState(null)
  const [localeSystem, setLocaleSystem] = useState(languages.en)
  const [coverPage, setCoverPage] = useState({})
  const [panel, setPanel] = useState({})

  useEffect(() => {
    const downloadPdf = ({
      items,
      typeDownload,
      localeSystem,
      reportTitle,
      isHasReportSubtitle,
      reportSubtitle,
      panel,
      isHasCompanyName,
      isHasPortName,
    }) => {
      setItems(items)
      setTypeDownload(typeDownload)
      setLocaleSystem(localeSystem)
      setCoverPage({
        reportTitle,
        isHasReportSubtitle,
        reportSubtitle,
        isHasCompanyName,
        isHasPortName,
      })
      setPanel(panel)
    }
    EventEmitter.subscribe(DOWNLOAD_PDF, downloadPdf)
    return () => EventEmitter.unsubscribe(DOWNLOAD_PDF, downloadPdf)
  }, [])

  const setDefault = () => {
    setItems(null)
    setData(null)
    setTypeDownload(null)
    setLocaleSystem(languages.en)
    setCoverPage({})
    setPanel({})
    EventEmitter.dispatch(END_PROCESS_DOWNLOAD_PDF)
  }

  return (
    <>
      {items && (
        <LoadingPdf localeSystem={localeSystem} setDefault={setDefault} />
      )}
      {!items ? (
        <></>
      ) : items && !data ? (
        <ComponentsToPdfData
          items={items}
          onDone={(result) => setData(result)}
        />
      ) : typeDownload === TYPE_DOWNLOAD.PREVIEW_SINGLE_BOX ? (
        <PopupPreviewSingleBox
          panel={panel}
          data={data.filter(
            (item) => !(item?.isLandscape && !!item?.items.length),
          )}
          setDefault={setDefault}
        />
      ) : (
        <PdfDataToPdfFile
          data={data.filter(
            (item) => !(item?.isLandscape && !item?.items.length),
          )}
          setDefault={setDefault}
          typeDownload={typeDownload}
          coverPage={coverPage}
        />
      )}
    </>
  )
}

export default Pdf
